<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
  <path
    class="spark-1"
    d="M12.6699 6.00326L11.8366 4.16992L10.0033 3.33659L11.8366 2.50326L12.6699 0.669922L13.5033 2.50326L15.3366 3.33659L13.5033 4.16992L12.6699 6.00326Z"
  />
  <path
    class="spark-2"
    d="M12.6699 15.3366L11.8366 13.5033L10.0033 12.6699L11.8366 11.8366L12.6699 10.0033L13.5033 11.8366L15.3366 12.6699L13.5033 13.5033L12.6699 15.3366Z"
  />
  <path
    class="spark-3"
    d="M6.00326 13.3366L4.33659 9.66992L0.669922 8.00326L4.33659 6.33659L6.00326 2.66992L7.66992 6.33659L11.3366 8.00326L7.66992 9.66992L6.00326 13.3366Z"
  />
</svg>
